import React, { useState } from "react";
import PropTypes from "prop-types";
import PureModal from "components/ui/modal/pure-modal";
import MdSettings from "react-icons/lib/md/settings";
import { assocPath, pathOr } from "ramda";

const TableSettings = ({ updateTableSettings, tableSettings, columns }) => {
  const [tmpTableSettings, setTmpTableSettings] = useState(tableSettings);
  const toggleColumn = (field, checked) => {
    setTmpTableSettings(settings =>
      assocPath([field, "active"], checked, settings)
    );
  };
  const isColumnVisible = field =>
    pathOr(true, [field, "active"], tmpTableSettings);
  return (
    <PureModal
      renderTrigger={({ openModal }) => (
        <span className="icon-button" onClick={openModal}>
          <MdSettings />
        </span>
      )}
      style={{ overflow: "hidden" }}
      renderContent={({ closeModal }) => (
        <div style={{ padding: "10px 0px" }}>
          <h5 style={{ paddingLeft: 5 }}>Table Columns</h5>
          <div
            style={{
              padding: 5,
              overflow: "auto",
              border: "1px solid #ccc",
              maxHeight: "calc(100vh - 305px)",
              display: "grid",
              gridTemplateColumns: "1fr 1fr"
            }}
          >
            {columns.map(({ field, header }) => (
              <label
                key={field}
                style={{
                  marginLeft: 20,
                  padding: 5,
                  display: "flex",
                  fontSize: 16,
                  alignItems: "center"
                }}
              >
                <input
                  type="checkbox"
                  checked={isColumnVisible(field)}
                  onChange={({ target: { checked } }) =>
                    toggleColumn(field, checked)
                  }
                  style={{ margin: 0 }}
                />
                <span style={{ marginLeft: 10 }}>{header}</span>
              </label>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              marginTop: 5,
              padding: 5,
              justifyContent: "space-between"
            }}
          >
            <button
              onClick={() => {
                closeModal();
              }}
              className="button warning danger"
              style={{ margin: 0 }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                updateTableSettings(tmpTableSettings);
                closeModal();
              }}
              style={{ margin: 0 }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    />
  );
};

TableSettings.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired
    })
  ).isRequired,
  updateTableSettings: PropTypes.func.isRequired,
  tableSettings: PropTypes.object.isRequired,
  resetTableSettings: PropTypes.func.isRequired
};

export default TableSettings;
